class LiveSearch extends HTMLElement {
  static observedAttributes = ["q"];

  constructor() {
    super();

    this.currentQueryId = 0;
  }

  connectedCallback() {}

  disconnectedCallback() {}

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "q") {
      this._fetchQuery(newValue);
    }
  }

  _fetchQuery(q) {
    if (q.trim() === "") {
      this.innerHTML = "";
      return;
    }

    var requestResponse;

    this.currentQueryId++;
    const queryId = this.currentQueryId;
    fetch(
      `${this.url}?q=${q}&resources[type]=product,article,query&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,vendor,body&section_id=predictive-search`
    )
      .then((response) => {
        requestResponse = response;
        return response.text();
      })
      .then((text) => {
        if (!requestResponse.ok) {
          throw new Error(`${requestResponse.status}: ${text}`);
        }

        if (queryId !== this.currentQueryId) return;

        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        this.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  get url() {
    return this.getAttribute("url");
  }
}

if (!customElements.get("live-search")) {
  customElements.define("live-search", LiveSearch);
}
